import { BetalningsvillkorVyer } from './Betalningsvillkor/Betalningsvillkor';
import { LeveransvillkorVyer } from './Leveransvillkor/Leveransvillkor';
import { MomsVyer } from './Moms/Moms';
import { ValutaVyer } from './Valuta/Valuta';
import { BakgrundsjobbVyer } from './Bakgrundsjobb/Bakgrundsjobb';
import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { initConst } from '../../../../Utils/utils';
import { UserVyer } from './User/User';
import { OversiktRapporterVyer } from './OversiktRapporter/OversiktRapporterVy';

export const SYSVyer = initConst<IComponentsConfig>(() => ({
  SYSUser: UserVyer,
  SYSBetalningsvillkor: BetalningsvillkorVyer,
  SYSLeveransvillkor: LeveransvillkorVyer,
  SYSMoms: MomsVyer,
  SYSValuta: ValutaVyer,
  SYSJobb: BakgrundsjobbVyer,
  SYSReportNew: OversiktRapporterVyer,
}));
